import * as React from "react";
import { Context } from "react";
import LoadingIcon from "conference/components/svg-icons/LoadingIcon";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const ControlBarIconContainer = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            width: "1.13em",
            height: "1.13em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}
    >
        {children}
    </div>
);

export const createContextProvider = (context: Context<any>, valueHook: () => any) => {
    const ContextProvider = context;

    return ({ children }: { children: React.ReactNode }) => (
        <ContextProvider.Provider value={valueHook()}>{children}</ContextProvider.Provider>
    );
};

export const Center = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
        }}
    >
        {children}
    </div>
);

export const Connecting = () => (
    <Center>
        <LoadingIcon />
        <Typography style={{ marginTop: 10 }}>
            <FormattedMessage id="meetingPage.room.connecting" defaultMessage="Connecting..." />
        </Typography>
    </Center>
);
